import React, { useState } from 'react';
import { Snackbar, Alert, AlertColor, AlertTitle } from '@mui/material';

interface AlertCustomProps {
    message: string;
    id: number;
    offset: number;
    removeAlert: (id: number) => void;
    severity?: AlertColor;
    title?: string;
}

const AlertCustom: React.FC<AlertCustomProps> = ({ id, offset, removeAlert, message, title = "", severity = "info" }) => {
    const [open, setOpen] = useState(true);
    // Le sumamos 70 para que aparezca debajo del topBar
    offset = offset + 70;
    // Cuando se cierra una alerta se elimina de la lista de activas
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        removeAlert(id);
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            key={id}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            style={{ top: offset }}
        >
            <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }} variant="filled">
                {title && <AlertTitle>{title}</AlertTitle>}
                {message}
            </Alert>
        </Snackbar>
    );
};

export default AlertCustom;
